module.exports = __webpack_public_path__ + "img/data_ld.ac7dad76.png";